<template>
  <SectionWrapper sectionId="recruit">
    <SectionContainer>
      <Heading :titleImgSrc="headingData.img" :titleText="headingData.text" :leading="headingData.leading" :description="headingData.description" />
      <ContentContainer>
        <div class="recruit">
          <article class="recruit_item" v-for="(article, index) in recruitList" :key="index">
            <a class="recruit_link" :href="article.href">
              <img class="recruit_img" :src="article.img" alt="">
              <div class="recruit_title">
                <h3>{{article.title}}</h3>
              </div>
            </a>
          </article>
        </div>
      </ContentContainer>
    </SectionContainer>
  </SectionWrapper>
</template>

<script>
import Heading from '../atoms/Heading'
import SectionWrapper from '../atoms/SectionWrapper'
import SectionContainer from '../atoms/SectionContainer'
import ContentContainer from '../atoms/ContentContainer'

import recruitTeamImage from '../../assets/images/recruit_team@2x.png'
import recruitCompanyImage from '../../assets/images/recruit_company@2x.png'
export default {
  name: 'recruit',
  components: {
    Heading,
    SectionWrapper,
    SectionContainer,
    ContentContainer
  },
  data () {
    return {
      recruitTeamImage,
      recruitCompanyImage,
      headingData: {
        img: require('@/assets/images/title_recruit.svg'),
        text: 'recruit',
        leading: '採用情報',
        description: 'build serviceは、尊いビジョンを掲げる組織の変革に思いを込めて伴走するプロフェッショナルなメンバーを積極採用中です。エンジニア、ソリューションオーナーなど幅広くメンバーを募集しております。'
      },
      recruitList: [
        {
          img: require('@/assets/images/recruit_team@2x.png'),
          href: 'https://note.com/build_service',
          title: 'チームについて知りたい方'
        },
        {
          img: require('@/assets/images/recruit_company@2x.png'),
          href: 'https://www.wantedly.com/companies/company_813567',
          title: '採用について知りたい方'
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/stylesheets/variables';
@import '../../assets/stylesheets/mixins';

.recruit {
  @include bpOnlyPc() {
    display: flex;
    justify-content: space-between;
  }
  &_item {
    max-width: 430px;
    @include bpOnlyPc() {
      flex-grow: 1;
    }
    @include bpOnlySp() {
      margin: auto;
    }
    &:last-of-type {
      @include bpOnlyPc() {
        margin-left: 40px;
      }
      @include bpOnlySp() {
        margin-top: 40px;
      }
    }
  }
  &_link {
    display: block;
  }
  &_img {
    width: 100%;
  }
  &_title {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 70px;
    font-size: 20px;
    color: $buildNavy;
    background: $white;
  }
}
</style>
